import Laboratory from "@/views/laboratory/laboratory"

export default {
    path: '/Laboratory',
    name: 'Laboratory',
    component: Laboratory,
  }


// WEBPACK FOOTER //
// ./src/router/laboratory/index.js